import React from "react";
import { FieldError } from "../../../common/fields";
import RadioButton from "../../../common/fields/base/Radio";
import { formatPhoneNumber2 } from "../../../../utils";

const OtpOptions = (props) => {
  const {
    otpDispatchErrors,
    email,
    phoneNumber,
    infoText,
    selectedOtpChannel,
    setSelectedOtpChannel,
    isLandlineSMS,
  } = props;
  const formattedPhoneNumber = formatPhoneNumber2(phoneNumber);

  const handleChange = (e) => {
    setSelectedOtpChannel(e.target.value);
  };

  const getRadioButtonLabel = (channel, phoneOrEmail) => (
    <>
      <div className="radBoldedLabel radLabel">{channel}:</div>
      <div>{phoneOrEmail}</div>
    </>
  );
  return (
    <>
      <div className="otp-modal-fields u__medium u__bold otp-modal-info-text">
        {infoText}
      </div>
      {!!otpDispatchErrors.length &&
        <div className="otp-options-view-error col__12-12 no-padding-sides form-input--error">
          <FieldError name="otp" errors={otpDispatchErrors} />
        </div>
      }
      <div className="otp-modal-fields otp-options-view-comp">How should we send the verification code?</div>
      <div className="otp-options-modal otp-modal-fields">
        {!isLandlineSMS ? <RadioButton className="u--paddingLarge-right" label={getRadioButtonLabel("Text", formattedPhoneNumber)} id="sms" value="sms"
          name="otpChannel" selectedValue={selectedOtpChannel} onChange={handleChange} /> : <></>}
        <RadioButton label={getRadioButtonLabel("Phone Call", formattedPhoneNumber)} id="evoice" value="phone" name="otpChannel"
          selectedValue={selectedOtpChannel} onChange={handleChange} />
        <RadioButton label={getRadioButtonLabel("Email", email)} id="emailId" value="email" name="otpChannel" className="otp-modal-email-field__email-break"
          selectedValue={selectedOtpChannel} onChange={handleChange} />
      </div>
    </>
  );
};

export default OtpOptions;